import Chevron from "assets/icons/chevron.svg"
import { FormattedMessage } from "react-intl"
import styled from "styled-components"

import { TextButton } from "./TextButton"
import { ButtonProps } from "./types"

export const StyledBack = styled(TextButton)`
  display: flex;
  align-items: center;

  svg {
    height: 12px;
    stroke: ${(props) => props.theme.colors.dark};
    transform: rotate(-90deg);
    margin-right: 2px;
  }

  @media (hover: hover) {
    &:hover {
      svg {
        stroke-width: 1.5px;
      }
    }
  }
`

const BackButton = ({
  onClick = () => {},
  type = "button",
  disabled = false,
}: ButtonProps) => (
  <StyledBack type={type} onClick={onClick} disabled={disabled}>
    <Chevron />
    <FormattedMessage id="checkout.back" defaultMessage="Back" />
  </StyledBack>
)

export default BackButton
